import { useSelector } from 'react-redux'
import useUserRole from 'src/hooks/useUserRole'
import { canAccess } from 'src/utils/permissions'

export const useVenueCustomRoles = () =>
  useSelector(state => state.venue.venue?.customRoles) || []

export const useCanAccess = screen => {
  const role = useUserRole()
  const customRoles = useVenueCustomRoles()
  return canAccess(screen, role, customRoles)
}

const useIsBlocked = screen => !useCanAccess(screen)

export default useIsBlocked
